import React from 'react'

import header from './../../../UI/general/header.svg'
import logoAuteco from './../../../UI/logos/logo-auteco.svg'

import fullOff from './../../../UI/general/Header/full-off.svg'
import fullOn from './../../../UI/general/Header/full-on.svg'

import audioOff from './../../../UI/general/Header/audio-off.svg'
import audioOn from './../../../UI/general/Header/audio-on.svg'

import handleOpenFullScreen from './../../../utils/fullscreen'

import star from './../../../UI/general/star.svg'

interface Props{
    handleToogleMenu: any,
    isMenuOpened: boolean,
    isFullScreen: boolean,
    isMuted: boolean,
    handleFullScreen: any
    handleAudio: any,
    handleMotoMes: any
} 

interface State{
    isFullScreen: boolean,
    isMuted: boolean
}

class HeaderDesktop extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            isFullScreen: false,
            isMuted: false
        }
    }


    render(){
        return(
            <div className='header-component'>
                <img src={header} className="header-image"/>
                <img src={logoAuteco} className='header-logo'/>
                <div className='fullscreen-container' onClick={() => {this.props.handleFullScreen()}}>
                    <img src={this.props.isFullScreen ? fullOn:fullOff} />
                </div>
                <div className='audio-container' onClick={() => {this.props.handleAudio()}}>
                    <img src={this.props.isMuted ? audioOff:audioOn} />
                </div>
                <div className='moto-del-mes-container' onClick={() => {this.props.handleMotoMes()}}>
                    <img src={star}></img>
                    <div>Destacado del mes</div>
                </div>
                <div className='menu-btn-container' onClick={() => {this.props.handleToogleMenu()}}>
                    <div className={this.props.isMenuOpened ? 'line top-line-selected':'line top-line'}></div>
                    <div className={this.props.isMenuOpened ? 'line middle-line-selected':'line middle-line'}></div>
                    <div className={this.props.isMenuOpened ? 'line bottom-line-selected':'line bottom-line'}></div>
                </div>
            </div>
        )
    }
}

export default HeaderDesktop